import axios from "axios";

export const fetchVersion = async () => {
    const response = await axios.get("api/version/");
    const version = response.data;
    return version;
}